import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectLoginTokenInfo } from "../../../../redux/features/loginRegisterSlice";
import useDomesticHelperFlow from "../../../../hooks/useDomesticHelperFlowSimple";
import { STEP_NAME_START } from "../../../../pages/domesticHelperPages/newDomesticHelperPolicy/data";
import BasicInfo from "./basicInfo/basicInfo";
import DocumentsReadyInfo from "./documentsReadyInfo/documentsReadyInfo";
import "./startPage.css";

const DomesticHelperStartPage = ({ onClose }) => {
  const { currentStep, currentSubstepIndex, handleNextSubstep, handlePrevSubstep } = useDomesticHelperFlow();
  const loginTokenInfo = useSelector(selectLoginTokenInfo);
  const isLoggedin = !!loginTokenInfo;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const w = queryParams.get("w") === "true"; // Website redirect
  const e = queryParams.get("email") || ""; // Email parameter

  // If logged in or redirected from website, skip user info step.
  // Guarded with a ref so the call can only fire ONCE per mount — without
  // this, the parent's popLayout crossfade keeps this component mounted for
  // ~150ms during exit, and any dependency churn (e.g. substep index resetting
  // to 0 as the next step begins) could re-trigger handleNextSubstep and
  // cascade past the intended destination.
  const hasAutoAdvanced = useRef(false);
  useEffect(() => {
    if (hasAutoAdvanced.current) return;
    // Only auto-advance while we're actually on the START step. During the
    // AnimatePresence exit (~150ms), this component stays mounted as Redux
    // already advances to the next step (substepIndex resets to 0), which
    // would otherwise re-trigger handleNextSubstep on a step that has no
    // substeps and cascade past the intended destination.
    if (currentStep?.name !== STEP_NAME_START) return;
    if (isLoggedin && currentSubstepIndex !== 1) {
      hasAutoAdvanced.current = true;
      handleNextSubstep();
      return;
    }
    if ((w || e) && currentSubstepIndex !== 1) {
      hasAutoAdvanced.current = true;
      handleNextSubstep();
    }
  }, [currentStep?.name, isLoggedin, currentSubstepIndex, handleNextSubstep, w, e]);

  const handleBackToForm = () => {
    // Go back to previous substep (BasicInfo)
    handlePrevSubstep();
  };

  return (
    <div className="flex flex-col items-center gap-6 bg-white max767:p-5">
      {isLoggedin ? (
        currentSubstepIndex === 1 ? (
          <DocumentsReadyInfo
            continueClickHandler={handleNextSubstep}
            hide_back_btn={true}
            show_close_btn={true}
            onClose={onClose}
          />
        ) : (
          <div className="p-4">Loading...</div>
        )
      ) : (
        <>
          {currentSubstepIndex === 0 ? (
            <BasicInfo continueClickHandler={handleNextSubstep} onClose={onClose} />
          ) : currentSubstepIndex === 1 ? (
            <DocumentsReadyInfo
              continueClickHandler={handleNextSubstep}
              hide_back_btn={false}
              show_close_btn={false}
              onClose={onClose}
              customBackHandler={handleBackToForm}
            />
          ) : (
            <div className="p-4">Loading...</div>
          )}
        </>
      )}
    </div>
  );
};

export default DomesticHelperStartPage;